import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

const DateStep = ({ fields, formatDate, onFromDateChange, onToDateChange }) => (
  <div className="step-content">
    <h2>Leigutími</h2>
    <p>
      Veldu hvenær eignin þín er laus til útleigu
    </p>
    <div className="date-picker">
      <DatePicker
        DateTimeFormat={window.DateTimeFormat}
        locale="is"
        formatDate={formatDate}
        minDate={new Date()}
        value={new Date(fields.availableFrom.value)}
        onChange={(e, date) => onFromDateChange(fields, date)}
        hintText="Laus frá"
        okLabel="Staðfesta" cancelLabel="Hætta við"
        fullWidth
      />
    </div>
    <p className="second-text">Ef um skammtímaleigu er að ræða skaltu velja hvenær þú þarft eignina aftur.</p>
    <div className="date-picker">
      <RadioButtonGroup {...fields.rentTimeType} name="rentTimeType" className="radio-button-wrapper" defaultSelected={fields.rentTimeType.value || 'Langtímaleiga'}>
        <RadioButton value="Langtímaleiga" label="Langtímaleiga" />
        <RadioButton value="Skammtímaleiga" label="Skammtímaleiga" />
      </RadioButtonGroup>
      <div className={`${fields.rentTimeType.value === 'Langtímaleiga' ? 'hidden-input' : ''}`} >
        <h3>Leigist til</h3>
        <DatePicker
          DateTimeFormat={window.DateTimeFormat}
          locale="is"
          formatDate={formatDate}
          minDate={new Date(fields.availableFrom.value)}
          value={fields.availableTo.value === '' ? new Date(fields.availableFrom.value) : new Date(fields.availableTo.value)}
          onChange={(e, date) => onToDateChange(fields, date)}
          hintText="Laus til" okLabel="Staðfesta" cancelLabel="Hætta við"
          fullWidth
        />
      </div>
    </div>
  </div>
);

DateStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  formatDate: React.PropTypes.func.isRequired,
  onFromDateChange: React.PropTypes.func.isRequired,
  onToDateChange: React.PropTypes.func.isRequired,
};

export default DateStep;



// WEBPACK FOOTER //
// ./src/browser/steps/DateStep/DateStep.js